import { render, staticRenderFns } from "./WysiwygEditor.vue?vue&type=template&id=6ba4ebb2"
import script from "./WysiwygEditor.vue?vue&type=script&lang=js"
export * from "./WysiwygEditor.vue?vue&type=script&lang=js"
import style0 from "./WysiwygEditor.vue?vue&type=style&index=0&id=6ba4ebb2&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/francescobarbieri/Dev/brain/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ba4ebb2')) {
      api.createRecord('6ba4ebb2', component.options)
    } else {
      api.reload('6ba4ebb2', component.options)
    }
    module.hot.accept("./WysiwygEditor.vue?vue&type=template&id=6ba4ebb2", function () {
      api.rerender('6ba4ebb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/admin-panel/components/tasks/WysiwygEditor.vue"
export default component.exports